import * as Sentry from '@sentry/remix';
import { RemixBrowser, useLocation, useMatches } from '@remix-run/react';
import { startTransition, StrictMode, useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';

const isProduction = window.ENV.NODE_ENV === 'production';

if (isProduction || window.ENV.SENTRY_ENABLED === 'true') {
  Sentry.init({
    dsn: window.ENV.SENTRY_DSN,
    tracesSampleRate: isProduction ? 1 : 0,
    debug: true,
    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
      Sentry.replayIntegration(),
    ],
  });
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
